export default __webpack_public_path__ + "media/ericVid.8fa54203.mp4";